import React, { Component } from "react";
import { Checkbox } from "semantic-ui-react";
import { connect } from "react-redux";
import "./Settings.scss";
import { SendNotificationSettings } from "../../../actions/globalAction";
import { ReactComponent as InfoIcon } from "../../../assets/svg/info-icon.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { ReactComponent as EnableSoundIcon } from "../../../assets/svg/Enable-sound.svg";
import { ReactComponent as DisableSoundIcon } from "../../../assets/svg/Disable-sound.svg";
class NotificationSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            createdCollection: props?.notification_alert?.smr_ticket_assigned?.web ? props.notification_alert.smr_ticket_assigned.web.is_enabled : true,
            updatedCollection:
                props.notification_alert &&
                    props.notification_alert.collection &&
                    props.notification_alert.collection.edited &&
                    props.notification_alert.collection.edited === "1"
                    ? true
                    : false,
            alertEmails: props.notification_alert && props.notification_alert.report && props.notification_alert.report.sent === "1" ? true : false,
            notificationSoundEnabled: true,
        };
    }

    componentDidMount() {
        if (!localStorage.getItem("notificationSoundEnabled")) {
            localStorage.setItem("notificationSoundEnabled", true);
            this.setState({
                notificationSoundEnabled: true,
            });
        }
        else {
            this.setState({
                notificationSoundEnabled: localStorage.getItem("notificationSoundEnabled") === "true",
            });
        }
    }

    onToggling = (mode) => {
        let reqBody = {};
        this.setState(
            {
                [mode]: !this.state[mode],
            },
            () => {
                let param = {
                    notification_alert: {
                        smr_ticket_assigned: { web: { is_enabled: this.state.createdCollection ? true : false } },
                    },
                };
                this.props.SendNotificationSettings({
                    param,
                    value: this.state.createdCollection,
                    // created: this.state.createdCollection ? "1" : "0",
                    // edited: this.state.updatedCollection ? "1" : "0",
                    // sent: this.state.alertEmails ? "1" : "0",
                });
            },
        );
    };

    handleToggleNotificationSound = () => {
        if (this.state.notificationSoundEnabled) {
            localStorage.setItem("notificationSoundEnabled", "false");
        } else {
            localStorage.setItem("notificationSoundEnabled", "true");
        }
        this.setState(
            {
                notificationSoundEnabled: localStorage.getItem("notificationSoundEnabled") === "true",
            },
            () => {
                let param = {
                    notification_alert: {
                        notification_sound: { web: { is_enabled: this.state.notificationSoundEnabled } },
                    },
                };
                this.props.SendNotificationSettings({
                    param,
                    value: this.state.createdCollection,
                });
            },
        );
    };

    render() {
        return (
            <div className="notification-settings">
                {this.props.packageObj?.features?.smr_module_access?.quota === 1 && (
                    <div className="settings-item">
                        <div className="new">Enable/Disable the sound</div>
                        <div className="toggle-box" onClick={this.handleToggleNotificationSound}>
                            <div className="icon-wrapper">{this.state.notificationSoundEnabled ? <EnableSoundIcon /> : <DisableSoundIcon />}</div>
                        </div>
                    </div>
                )}
                {this.props.packageObj?.features?.smr_module_access?.quota === 1 && (
                    <div className="settings-item">
                        <div className="new">Ticket Assigned</div>
                        <div className="toggle-box">
                            <Checkbox
                                toggle
                                checked={this.state.createdCollection}
                                onChange={() => this.onToggling("createdCollection")}
                                className="toggle-style"
                            />
                        </div>
                    </div>
                )}
                <div className="settings-item">
                    <div className="new">
                        Token Expiry
                        <Popup
                            inverted
                            className="skiptranslate"
                            size="tiny"
                            position="bottom right"
                            content="You can not disable this notification since it's a system notification and it's needed for smooth flow of your token."
                            trigger={<InfoIcon className="info__icon" />}
                            style={{ zIndex: 9999999, backgroundColor: "#112C5A", width: "600px" }}
                        />
                    </div>
                    <div className="toggle-box">
                        <Checkbox
                            toggle
                            checked={true}
                            // onChange={() => this.onToggling("createdCollection")}
                            className="toggle-style"
                            disabled
                        />
                    </div>
                </div>
                {/* <div className="settings-item">
                    <div className="new">Collection edited</div>
                    <div className="toggle-box">
                        <Checkbox
                            toggle
                            checked={this.state.updatedCollection}
                            onChange={() => this.onToggling("updatedCollection")}
                            className="toggle-style"
                        />
                    </div>
                </div>
                <div className="settings-item border-alert">
                    <div className="new">Reports & Alerts email</div>
                    <div className="toggle-box">
                        <Checkbox toggle checked={this.state.alertEmails} onChange={() => this.onToggling("alertEmails")} className="toggle-style" />
                    </div>
                </div> */}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        notification_alert: state.globalReducer.user.notification_alert,
        user: state.globalReducer.user,
        packageObj: state.globalReducer.packageObj,
    };
};

export default connect(mapStateToProps, { SendNotificationSettings })(NotificationSettings);
